import _ from "lodash";

import { Service } 		from "./../../Libs/Service";
import {Asset} from "./Asset";
import {Server} from "./Server";
import {Metadata} from "./Metadata";

let Section = new Service({

	Name: "Section",

	Events: {

	},

	Actions: {

		'ProjectSections': function(sections) {

			this.updateSections(sections);

			Broadcast.call("Sections Changed", [sections]);

		},

		'SectionChanged': function(sectionId) {

			Broadcast.call("Section Changed", [this.Section[sectionId]]);

		},

		'SectionCreated': function(sectionId) {

			Broadcast.call("Section Created", [sectionId]);

		},

		'SectionRemoved': function(sectionId) {

			let projectId = Object.values(this.Sections).find(section_ => section_.id === sectionId).project_id;

			delete this.Sections[sectionId];
			delete this.SectionsByProject[projectId][sectionId];

			Broadcast.call("Section Removed", [sectionId]);

		}

	},

	init() {

		this.Sections = {};
		this.SectionsByProject = {};
		this.SectionsByProjectByCodename = {};

	},

	updateSections(sections) {

		let is_selected_project_sections_changed = false;

		_.each(sections, section => {

			let oldSection = this.Sections[section.id];

			this.Sections[section.id] = section;

			if (!this.SectionsByProject[section["project_id"]]) this.SectionsByProject[section["project_id"]] = {};
			this.SectionsByProject[section["project_id"]][section.id] = section;

			if (!this.SectionsByProjectByCodename[section["project_id"]]) this.SectionsByProjectByCodename[section["project_id"]] = {};
			this.SectionsByProjectByCodename[section["project_id"]][section['codename']] = section;

			section.isChanged = this.isChangedSection(section);

			let templateSections = Metadata.TemplateSectionsByTemplateIdByCodename[section["template_id"]];

			if (templateSections) {

				let templateSection = templateSections[section["codename"]];

				_.defaults(section, templateSection);

			}

			if (Project.SelectedProject && section["project_id"] === Project.SelectedProject.id) is_selected_project_sections_changed = true;

			//if (oldSection) section.Data['highlighted'] = oldSection.Data['highlighted'];

		});

		if (is_selected_project_sections_changed) Broadcast.call("Selected Project Sections Changed", [sections]);

	},

	//Возвращаем секции текущей версии проекта
	getSelectedProjectSections() {

		if (!Template.SelectedTemplate) return null;

		//Секции проекта
		if (Project.SelectedProject) {

			return _.values(this.SectionsByProject[Project.SelectedProject.id]);

		//Секции по умолчанию от шаблона
		} else {

			return _.values(_.cloneDeep(Metadata.TemplateSectionsByTemplateId[Template.SelectedTemplate.id]));

		}

	},

	getSelectedProjectSectionsById() {

		return _.keyBy(this.getSelectedProjectSections(), 'id');

	},

	getSelectedProjectSectionsByCodename() {

		return _.keyBy(this.getSelectedProjectSections(), 'codename');

	},

	getBackgroundColorForSection(section, property, assetName) {
		let assets = Asset.getSelectedProjectMergedAssets();

		if (assets[assetName]) {

			let img = new Image();

			img.crossOrigin = "";
			img.onload = () => {

				let color = Settings.getImageBorderColor(img);

				Section.saveSectionData(section, property, color);

			};

			img.src = assets[assetName]['url'];

		}
	},

	//Изменена ли настройка относительно того какое значение было изначально в шаблоне
	isChangedSection(section) {

		if (!section) return;
		if (!section["template_id"]) return;


		let templateSections = Metadata.TemplateSectionsByTemplateIdByCodename[section["template_id"]];
		if (!templateSections) return;

		let templateSection = templateSections[section["codename"]];
		if (!templateSection) return;

		//TODO: complete comparison

		//console.log('isChangedSection', section["type"], templateSection["type"]);

		return section["type"] !== templateSection["type"];

	},

	saveSectionStyle_(section, propertyName, value) {

		if (!section.Data.styles) section.Data.styles = {};

		section.Data['styles'][propertyName] = value;

		Server.sendToSocket({
			SetSectionStyle: {
				sectionId: section.id,
				propertyName: propertyName,
				value: value
			}
		});

	},

	saveSectionData(section, propertyName, value) {

		if (propertyName === 'numberOfScreens') {
			let numberOfScreens = section.Data.numberOfScreens ? parseInt(section.Data.numberOfScreens) : 4;
			let newVal = parseInt(value);
			if (newVal < numberOfScreens) {
				for (let i = newVal + 1; i < numberOfScreens + 1; i++) {
					let asset = Asset.AssetsByProjectByCodename[section.project_id][`navigation-${i}`];
					if (asset) Asset.removeAsset(asset);
				}
			}
			else {
				for (let i = numberOfScreens + 1; i < newVal + 1; i++) {
					if (!Asset.AssetsByProjectByCodename[section.project_id][`navigation-${i}`]) {
						Server.sendToSocket({
							CreateAsset: {
								projectId: section.project_id,
								codename: `navigation-${i}`,
								asset_type: 'image',
								url: '',
								additional_data: {},
								tags: 'custom'
							}
						});
					}
				}
			}
		}

		if (propertyName === 'auto-dimensions' && value === true) {
			let img = new Image();
			img.src = Asset.getAssetActualUrl(Asset.AssetsByProject[section.project_id][section.Data.assetId]);
			img.onload = () => {
				Server.sendToSocket({
					SetSectionData: {
						sectionId: section.id,
						propertyName: 'width',
						value: img.naturalWidth
					}
				});
				Server.sendToSocket({
					SetSectionData: {
						sectionId: section.id,
						propertyName: 'height',
						value: img.naturalHeight
					}
				});
			}
		}

		if (propertyName === 'twitch-use-iframe' || propertyName === 'disable-parallax' || propertyName === 'spawn-as-overlay' || propertyName === 'hover-area' || propertyName === 'changed-asset' || propertyName === 'move-to-fixed') {
			//Broadcast.call("Send to IFrame", [{refresh: {}}]);
			Broadcast.call("Preview Refresh");
		}

		if (propertyName === 'deezer-url') {

			Server.sendToSocket({
				SetSectionDeezer: {
					sectionId: section.id,
					deezerUrl: value
				}
			});
		}

		if (section.template_id === 5) {
			if (propertyName === 'include-video' && section.Data['include-twitch']) {
				this.saveSectionData(section, 'include-twitch', false);
			}
			else if (propertyName === 'include-twitch' && section.Data['include-video']) {
				this.saveSectionData(section, 'include-video', false);
			}
			Broadcast.call("Preview Refresh");
		}

		Server.sendToSocket({
			SetSectionData: {
				sectionId: section.id,
				propertyName: propertyName,
				value: value
			}
		});

	},

	saveSectionVideoForMobile(section, propertyName, value, videoName) {

		Server.sendToSocket({
			SetSectionData: {
				sectionId: section.id,
				propertyName: propertyName,
				value: value
			}
		});


		let resolution = 16 / 9;
		if (Asset.Videos[videoName]) {
			let video = Asset.Videos[videoName];
			if (video.width && video.height) {
				resolution = video.width / video.height;
			}
		}

		Server.sendToSocket({
			SetSectionData: {
				sectionId: section.id,
				propertyName: 'video-resolution',
				value: resolution
			}
		});

	},

	saveSectionType(section, type) {

		Server.sendToSocket({
			SetSectionType: {
				sectionId: section.id,
				type: type
			}
		});

		if (type === 'amazon' || type === 'spotify' || type === 'deezer') {
			this.saveSectionData(section, 'width', 400);
			this.saveSectionData(section, 'height', 250);
		} else if (type === 'twitch') {
			this.saveSectionData(section, 'collapsedWidth', 400);
			this.saveSectionData(section, 'collapsedHeight', 250);
		}

		Broadcast.call("Preview Refresh");

	},

	resetSection(sectionId, data, type) {
		Server.sendToSocket({
			ResetSection: {
				sectionId: sectionId,
				data: data,
				type: type
			}
		});
	},

	saveSectionExpandSections(sectionId, expandSections) {
		Server.sendToSocket({
			SetSectionExpandSections: {
				sectionId: sectionId,
				expandSections: expandSections
			}
		});

	}

});

//Делаем глобальную ссылку для дебага - чтобы в консоли был виден этот объект сразу
window.Section = Section;

export { Section }

